import fieldMapping from './FieldMapping'
// import searchFields from '../../FiltersComponent/SearchFields/SearchFields'
// import APIInterceptor from '../../../../apis/APIInterceptors'
// import API from '../../../../../src/apis/API'
// import propertySearchAPIs from '../../../../../src/apis/propertySearchAPIs'
// import searchCriteria from '../../FiltersComponent/SearchCriteria/SearchCriteria'
import SearchCriteriaCls from '../../FiltersComponent/SearchCriteria/SearchCriteriaCls'
import SearchFieldsCls from '../../FiltersComponent/SearchFields/SearchFieldsCls'
import { fetchPropertySuggestion } from '../../Services/propertySearchService'

const suggestionCriteria = { geoLocation: { propertyName: '', propertyLocation: '' } }
let setSearchCriteria
let searchCriteria
let searchFields
let subjectExists = false
let isLoadSavedSearch = true
let setSearchFields
let setCriteriaProcessed
let omniViewSearchCriteria = {}
// subject + all
// const omniViewSearchCriteria = { "searchCriteria": [{ "ParameterCond": "( DISTANCE(PropertyAddress__c, GEOLOCATION(38.029915,-84.541969), 'mi') < 10)", "PageName": "PropertySearchNew", "ParameterName": "PointOfInterest", "ParameterValue": "Ashwood Apartments" }, { "ParameterCond": "(Type__c IN (%27Multifamily%27,%27Health Care%27))", "PageName": "PropertySearchNew", "ParameterName": "PropertyType", "ParameterValue": "Multifamily : All,Health Care : Assisted Living" }, { "ParameterCond": "( Affordable_Housing__c = %27Yes%27 OR AgeRestricted__c = true OR Military__c = true )", "PageName": "PropertySearchNew", "ParameterName": "TenantInfo", "ParameterValue": "Affordable | Age Restricted | Military" }, { "ParameterCond": "Most_Recent_Sale_Date__c != null and Most_Recent_Sale_Date__c >= 2021-01-01", "PageName": "PropertySearchNew", "ParameterName": "_salesStDate", "ParameterValue": "Sale Date > 01-01-2021" }, { "ParameterCond": "Most_Recent_Sale_Date__c != null and Most_Recent_Sale_Date__c <= 2021-01-31", "PageName": "PropertySearchNew", "ParameterName": "_salesEndDate", "ParameterValue": "Sale Date < 01-31-2021" }, { "ParameterCond": "Most_Recent_Sale_Price__c != null and Most_Recent_Sale_Price__c >= 1", "PageName": "PropertySearchNew", "ParameterName": "_salesPriceMin", "ParameterValue": "Sale Price > 1" }, { "ParameterCond": "Most_Recent_Sale_Price__c != null and Most_Recent_Sale_Price__c <= 2", "PageName": "PropertySearchNew", "ParameterName": "_salesPriceMax", "ParameterValue": "Sale Price < 2" }, { "ParameterCond": "Price_Unit__c != null and Price_Unit__c >= 1", "PageName": "PropertySearchNew", "ParameterName": "_pricePerMin", "ParameterValue": "Price per Unit > 1" }, { "ParameterCond": "Price_Unit__c != null and Price_Unit__c <= 2", "PageName": "PropertySearchNew", "ParameterName": "_pricePerMax", "ParameterValue": "Price per Unit < 2" }, { "ParameterCond": "Price_SF__c != null and Price_SF__c >= 1", "PageName": "PropertySearchNew", "ParameterName": "_pricePerSqMin", "ParameterValue": "Price per Sq. Ft. > 1" }, { "ParameterCond": "Price_SF__c != null and Price_SF__c <= 2", "PageName": "PropertySearchNew", "ParameterName": "_pricePerSqMax", "ParameterValue": "Price per Sq. Ft. < 2" }, { "ParameterCond": "Lender__c LIKE #Bank", "PageName": "Property_LoanFilters", "ParameterName": "_lender", "ParameterValue": "Lender : Bank" }, { "ParameterCond": "Origination_Date__c >= 2021-01-01", "PageName": "Property_LoanFilters", "ParameterName": "_orgStDate", "ParameterValue": "Origination Date > 01-01-2021" }, { "ParameterCond": "Origination_Date__c <= 2021-01-01", "PageName": "Property_LoanFilters", "ParameterName": "_orgEndDate", "ParameterValue": "Origination Date < 01-01-2021" }, { "ParameterCond": "Maturity_Date__c != null and Maturity_Date__c >= 2021-01-01", "PageName": "Property_LoanFilters", "ParameterName": "_maturityStDate", "ParameterValue": "Maturity Date > 01-01-2021" }, { "ParameterCond": "Maturity_Date__c != null and Maturity_Date__c <= 2021-01-01", "PageName": "Property_LoanFilters", "ParameterName": "_maturityEndDate", "ParameterValue": "Maturity Date < 01-01-2021" }, { "ParameterCond": "UPB__c >= 1", "PageName": "Property_LoanFilters", "ParameterName": "_loanAmountMin", "ParameterValue": "Loan Amount > 1" }, { "ParameterCond": "UPB__c <= 2", "PageName": "Property_LoanFilters", "ParameterName": "_loanAmountMax", "ParameterValue": "Loan Amount < 2" }, { "ParameterCond": "TotalUnits__c >= 1", "PageName": "PropertySearchNew", "ParameterName": "_unitsMin", "ParameterValue": "Units > 1" }, { "ParameterCond": "TotalUnits__c <= 2", "PageName": "PropertySearchNew", "ParameterName": "_unitsMax", "ParameterValue": "Units < 2" }, { "ParameterCond": "Size_SqFtUnit__c >= 1", "PageName": "PropertySearchNew", "ParameterName": "_averageSqMin", "ParameterValue": "Average Sq.Ft./Unit > 1" }, { "ParameterCond": "Size_SqFtUnit__c <= 2", "PageName": "PropertySearchNew", "ParameterName": "_averageSqMax", "ParameterValue": "Average Sq.Ft./Unit < 2" }, { "ParameterCond": "Average_Rent_SF__c >= 1", "PageName": "PropertySearchNew", "ParameterName": "_averageRentMin", "ParameterValue": "Average Rent/Sq.Ft. > 1" }, { "ParameterCond": "Average_Rent_SF__c <= 2", "PageName": "PropertySearchNew", "ParameterName": "_averageRentMax", "ParameterValue": "Average Rent/Sq.Ft. < 2" }, { "ParameterCond": "Year_Built__c >= %271900%27", "PageName": "PropertySearchNew", "ParameterName": "_yearBuiltMin", "ParameterValue": "Year Built > 1900" }, { "ParameterCond": "Year_Built__c <= %272020%27", "PageName": "PropertySearchNew", "ParameterName": "_yearBuiltMax", "ParameterValue": "Year Built < 2020" }, { "ParameterCond": "year_ren__c >= %271900%27", "PageName": "PropertySearchNew", "ParameterName": "_yearRenoMin", "ParameterValue": "Year Renovated > 1900" }, { "ParameterCond": "year_ren__c <= %272020%27", "PageName": "PropertySearchNew", "ParameterName": "_yearRenoMax", "ParameterValue": "Year Renovated < 2020" }, { "ParameterCond": "Occupancy__c >= 1", "PageName": "PropertySearchNew", "ParameterName": "_occupancyRanMin", "ParameterValue": "Occupancy > 1" }, { "ParameterCond": "Occupancy__c <= 2", "PageName": "PropertySearchNew", "ParameterName": "_occupancyRanMax", "ParameterValue": "Occupancy < 2" }, { "ParameterCond": "TotalBeds__c >= 1", "PageName": "PropertySearchNew", "ParameterName": "_bedsMin", "ParameterValue": "Beds > 1" }, { "ParameterCond": "TotalBeds__c <= 2", "PageName": "PropertySearchNew", "ParameterName": "_bedsMax", "ParameterValue": "Beds < 2" }, { "ParameterCond": "Size_SqFt__c >= 1", "PageName": "PropertySearchNew", "ParameterName": "_sqFtMin", "ParameterValue": "Sq. Ft. > 1" }, { "ParameterCond": "Size_SqFt__c <= 2", "PageName": "PropertySearchNew", "ParameterName": "_sqFtMax", "ParameterValue": "Sq. Ft. < 2" }, { "ParameterCond": "TotalRooms__c >= 1", "PageName": "PropertySearchNew", "ParameterName": "_roomsMin", "ParameterValue": "Rooms > 1" }, { "ParameterCond": "TotalRooms__c <= 2", "PageName": "PropertySearchNew", "ParameterName": "_roomsMax", "ParameterValue": "Rooms < 2" }, { "ParameterCond": "TotalSites__c >= 1", "PageName": "PropertySearchNew", "ParameterName": "_sitesMin", "ParameterValue": "Sites > 1" }, { "ParameterCond": "TotalSites__c <= 2", "PageName": "PropertySearchNew", "ParameterName": "_sitesMax", "ParameterValue": "Sites < 2" }, { "ParameterCond": "Acreage__c >= 1", "PageName": "PropertySearchNew", "ParameterName": "_acreageMin", "ParameterValue": "Acreage > 1" }, { "ParameterCond": "Acreage__c <= 2", "PageName": "PropertySearchNew", "ParameterName": "_acreageMax", "ParameterValue": "Acreage < 2" }, { "ParameterCond": "Average_Rent_Unit__c >= 1", "PageName": "PropertySearchNew", "ParameterName": "_avgRentMin", "ParameterValue": "Average Rent/Unit > 1" }, { "ParameterCond": "Average_Rent_Unit__c <= 2", "PageName": "PropertySearchNew", "ParameterName": "_avgRentMax", "ParameterValue": "Average Rent/Unit < 2" }, { "ParameterCond": "Average_Rent_Bed__c >= 1", "PageName": "PropertySearchNew", "ParameterName": "_avgBedMin", "ParameterValue": "Average Rent/Bed > 1" }, { "ParameterCond": "Average_Rent_Bed__c <= 2", "PageName": "PropertySearchNew", "ParameterName": "_avgBedMax", "ParameterValue": "Average Rent/Bed < 2" }, { "ParameterCond": "Average_Daily_Rate__c >= 1", "PageName": "PropertySearchNew", "ParameterName": "_avgDailyMin", "ParameterValue": "Average Daily Rate > 1" }, { "ParameterCond": "Average_Daily_Rate__c <= 2", "PageName": "PropertySearchNew", "ParameterName": "_avgDailyMax", "ParameterValue": "Average Daily Rate < 2" }, { "ParameterCond": "Revenue_Per_Av_Room__c >= 1", "PageName": "PropertySearchNew", "ParameterName": "_avgRevMin", "ParameterValue": "Average RevPar > 1" }, { "ParameterCond": "Revenue_Per_Av_Room__c <= 2", "PageName": "PropertySearchNew", "ParameterName": "_avgRevMax", "ParameterValue": "Average RevPar < 2" }, { "ParameterCond": "Parcel_Number__c LIKE #123", "PageName": "PropertySearchNew", "ParameterName": "_parcelNo", "ParameterValue": "Parcel Number : 123" }, { "ParameterCond": "Property_Manager__c LIKE #abc", "PageName": "PropertySearchNew", "ParameterName": "_propertyManager", "ParameterValue": "Property Manager : abc" }, { "ParameterCond": "(Zip_Code__c = %2765201%27)", "PageName": "PropertySearchNew", "ParameterName": "NearByLocation", "ParameterValue": "65201" }, { "ParameterCond": " Order By DISTANCE(PropertyAddress__c, GEOLOCATION(38.9372368,-92.3198929), 'mi') asc ", "PageName": "PropertySearchNew", "ParameterName": "OrderBy", "ParameterValue": "OrderBy" }] }

// multiple property subtype
// const omniViewSearchCriteria = { "searchCriteria": [{ "ParameterCond": "( DISTANCE(PropertyAddress__c, GEOLOCATION(38.029915,-84.541969), 'mi') < 10)", "PageName": "PropertySearchNew", "ParameterName": "PointOfInterest", "ParameterValue": "Lux - - Condos" }, { "ParameterCond": "(Type__c IN (%27Multifamily%27,%27Student Housing%27,%27Health Care%27,%27Hospitality%27))", "PageName": "PropertySearchNew", "ParameterName": "PropertyType", "ParameterValue": "Multifamily : Not Specified Multifamily,Condominiums / Townhouses,Cooperative Housing (Co-ops),Mobile Home / Manufactured Housing - Double,Single Family Home,Garden,Highrise,Midrise,Manufactured Housing,Other Multifamily,Student Housing : All,Health Care : Board and Care,Assisted Living,Congregate Care,Other Health Care,Skilled Nursing,Independent Living,Hospital,Not Specified Health Care,Hospitality : All" }, { "ParameterCond": " Order By DISTANCE(PropertyAddress__c, GEOLOCATION(39.724358,-104.982643), 'mi') asc ", "PageName": "PropertySearchNew", "ParameterName": "OrderBy", "ParameterValue": "OrderBy" }] }

// Listing checked
// const omniViewSearchCriteria = { "searchCriteria": [{ "ParameterCond": "((State__c = %27MO%27 AND City__c like %27%25 louis%25%27))", "PageName": "PropertySearchNew", "ParameterName": "PropertyAddressArea", "ParameterValue": "St. Louis" }, { "ParameterCond": "TotalUnits__c >= 100", "PageName": "PropertySearchNew", "ParameterName": "_unitsMin", "ParameterValue": "Units > 100" }, { "ParameterCond": "TotalUnits__c <= 200", "PageName": "PropertySearchNew", "ParameterName": "_unitsMax", "ParameterValue": "Units < 200" }, { "ParameterCond": "(BerkadiaListing__c = true OR OnMarket__c = true OR Berkadia_Brokered__c = true)", "PageName": "PropertySearchNew", "ParameterName": "marketInfo", "ParameterValue": "Berkadia Listings | Competitor Listings | Berkadia Brokered" }, { "ParameterCond": " Order By Name asc ", "PageName": "PropertySearchNew", "ParameterName": "OrderBy", "ParameterValue": "OrderBy" }] }

// subject + location
// const omniViewSearchCriteria = { "searchCriteria": [{ "ParameterCond": "(( DISTANCE(PropertyAddress__c, GEOLOCATION(35.8679701,-78.5613002), 'mi') < 100))", "PageName": "PropertySearchNew", "ParameterName": "PointOfInterest", "ParameterValue": "Luxury Apartments at Foxwood" }, { "ParameterCond": "(Type__c IN (%27Multifamily%27) and Subtype__c IN (%27Not Specified Multifamily%27,%27Garden%27,%27Other Multifamily%27))", "PageName": "PropertySearchNew", "ParameterName": "PropertyType", "ParameterValue": "Multifamily : Not Specified Multifamily,Garden,Other Multifamily" }, { "ParameterCond": "(State__c = %27NC%27 OR City__c = %27Spring Hope%27 OR City__c = %27Bethel%27 OR City__c = %27Apex%27 OR Property_County__c = %27Bladen%27 OR Zip_Code__c = %2727052%27 OR Property_County__c = %27Cumberland%27 OR State__c = %27VA%27 OR Property_County__c = %27Henry%27 OR Zip_Code__c = %2724528%27 OR Property_County__c = %27Charlotte%27)", "PageName": "PropertySearchNew", "ParameterName": "NearByLocation", "ParameterValue": "NC | Spring Hope | Bethel | Apex | Bladen | 27052 | Cumberland | VA | Henry | 24528 | Charlotte" }, { "ParameterCond": " Order By DISTANCE(PropertyAddress__c, GEOLOCATION(35.8679701,-78.5613002), 'mi') asc ", "PageName": "PropertySearchNew", "ParameterName": "OrderBy", "ParameterValue": "OrderBy" }] }

// Prospecting
// const omniViewSearchCriteria = { "searchCriteria": [{ "ParameterCond": "((State__c = %27TX%27 AND City__c like %27%25houston%25%27) OR (State__c = %27PA%27))", "PageName": "PropertySearchNew", "ParameterName": "PropertyAddressArea", "ParameterValue": "Houston | Pennsylvania" }, { "ParameterCond": "(Type__c IN (%27Multifamily%27) and Subtype__c IN (%27Not Specified Multifamily%27,%27Garden%27,%27Other Multifamily%27))", "PageName": "PropertySearchNew", "ParameterName": "PropertyType", "ParameterValue": "Multifamily : Not Specified Multifamily,Garden,Other Multifamily" }, { "ParameterCond": "Maturity_Date__c != null and Maturity_Date__c >= 2021-03-01", "PageName": "Property_LoanFilters", "ParameterName": "_maturityStDate", "ParameterValue": "Maturity Date > 03-01-2021" }, { "ParameterCond": "Maturity_Date__c != null and Maturity_Date__c <= 2023-01-01", "PageName": "Property_LoanFilters", "ParameterName": "_maturityEndDate", "ParameterValue": "Maturity Date < 01-01-2023" }, { "ParameterCond": " Order By Name asc ", "PageName": "PropertySearchNew", "ParameterName": "OrderBy", "ParameterValue": "OrderBy" }] }

// test 
// const omniViewSearchCriteria = { "searchCriteria": [{ "ParameterCond": "((State__c = %27AZ%27) OR (State__c = %27CA%27) OR (State__c = %27NM%27) OR (State__c = %27NV%27) OR (State__c = %27UT%27) OR (State__c = %27CO%27))", "PageName": "PropertySearchNew", "ParameterName": "PropertyAddressArea", "ParameterValue": "Arizona | California | New Mexico | Nevada | Utah | Colorado" }, { "ParameterCond": "(Type__c IN (%27Multifamily%27))", "PageName": "PropertySearchNew", "ParameterName": "PropertyType", "ParameterValue": "Multifamily : All" }, { "ParameterCond": "TotalUnits__c >= 100", "PageName": "PropertySearchNew", "ParameterName": "_unitsMin", "ParameterValue": "Units > 100" }, { "ParameterCond": "Most_Recent_Sale_Price__c != null and Most_Recent_Sale_Price__c >= 2000000", "PageName": "PropertySearchNew", "ParameterName": "_salesPriceMin", "ParameterValue": "Sale Price > 2000000" }, { "ParameterCond": "Most_Recent_Sale_Price__c != null and Most_Recent_Sale_Price__c <= 15000000", "PageName": "PropertySearchNew", "ParameterName": "_salesPriceMax", "ParameterValue": "Sale Price < 15000000" }, { "ParameterCond": " Order By Name asc ", "PageName": "PropertySearchNew", "ParameterName": "OrderBy", "ParameterValue": "OrderBy" }] }

export function getSearchCriteria(savedSearch) {
    isLoadSavedSearch = false
    const SearchCriteriaClsObj = new SearchCriteriaCls()
    let returnVal = SearchCriteriaClsObj.GetSearchCriteria()

    try {
        SetupSearchCriteriaAndFields()
        savedSearch = JSON.parse(savedSearch)

        for (const [key] of Object.entries(savedSearch)) {
            if (Array.isArray(savedSearch[key])) {
                // debugger
                if (key === 'distanceFields' || key === 'featureFields' || key === 'loanFields' || key === 'salesFields') {

                    savedSearch[key].forEach(field => {
                        if (field.isStartEnd) {
                            searchFields = setSearchFieldValue(searchFields, key, field.fieldName, 'startValue', field.startValue)
                            searchFields = setSearchFieldValue(searchFields, key, field.fieldName, 'endValue', field.endValue)
                        }
                        if (field.value) {
                            searchFields = setSearchFieldValue(searchFields, key, field.fieldName, 'value', field.value)
                        }
                        else {
                            searchFields = setSearchFieldValue(searchFields, key, field.fieldName, 'minValue', field.minValue)

                            if (field.isMinMax) {
                                searchFields = setSearchFieldValue(searchFields, key, field.fieldName, 'maxValue', field.maxValue)
                            }
                        }
                        returnVal = setSearchCriteriaValue(returnVal, key, field.fieldName)
                    })

                }
                if (key === 'locationFields') {
                    savedSearch[key].forEach(field => {
                        searchFields[key].push(field)
                        returnVal[key].push(field)
                        // searchFields = setSearchFieldValue(searchFields, key, field.fieldName, 'isChecked', true)
                    })
                }
                if (key === 'listingStatusFields') {
                    savedSearch[key].forEach(field => {
                        if (field.isChecked) {
                            searchFields = setSearchFieldValue(searchFields, key, field.fieldName, 'isChecked', true)
                        }
                        else if (field.isStartEnd) {
                            searchFields = setSearchFieldValue(searchFields, key, field.fieldName, 'startValue', field.startValue)
                            searchFields = setSearchFieldValue(searchFields, key, field.fieldName, 'endValue', field.endValue)
                        }
                        returnVal = setSearchCriteriaValue(returnVal, key, field.fieldName)
                    })
                }
                if (key === 'propertyTypeFields') {
                    savedSearch[key].forEach(field => {
                        const i = searchFields[key].findIndex(x => x.propertytype === field.propertytype && x.subtype === field.subtype)
                        if (i !== -1) {
                            searchFields[key][i].isChecked = true
                            returnVal[key].push(searchFields[key][i])
                        }

                    })
                }
                if (key === 'tenantInfoFields') {
                    searchFields[key] = savedSearch[key]
                    returnVal[key] = savedSearch[key]
                }
                if (key === 'accountFields') {
                    savedSearch[key].forEach(field => {
                        if (field.accountName) {
                            searchFields = setSearchFieldValue(searchFields, key, field.fieldName, 'accountName', field.accountName)
                            searchFields = setSearchFieldValue(searchFields, key, field.fieldName, 'accountId', field.accountId)
                        }

                        if (field.value) {
                            searchFields = setSearchFieldValue(searchFields, key, field.fieldName, 'value', field.value)
                        }

                        returnVal = setSearchCriteriaValue(returnVal, key, field.fieldName)
                    })
                }
                if (key === 'prospecting') {
                    searchCriteria[key] = savedSearch[key]
                    returnVal[key] = savedSearch[key]
                }
            } else {
                if (key === 'subjectProperty') {
                    searchCriteria.subjectProperty = savedSearch.subjectProperty
                    returnVal.subjectProperty = savedSearch.subjectProperty
                }
                if (key === 'property') {
                    searchCriteria.property = savedSearch.property
                    returnVal.property = savedSearch.property
                }
                if (key === 'sort') {
                    searchCriteria.sort = savedSearch.sort
                }
                if (key === 'polygon') {
                    searchCriteria.polygon = savedSearch.polygon
                }
            }
        }

    } catch (error) {
        console.log('error in getSearchCriteria = ', error)
    }

    // console.log('returnVal = ', returnVal)
    // console.log('searchFields = ', searchFields)
    return returnVal

}

export function loadSearchCriteria(savedSearch, setSearchFieldsIns, setSearchCriteriaIns, setCriteriaProcessedIns) {
    // SetupSearchCriteriaAndFields()

    // savedSearch = JSON.parse(savedSearch)
    isLoadSavedSearch = true
    setSearchCriteria = setSearchCriteriaIns
    // keycloak = keycloakIns
    setSearchFields = setSearchFieldsIns

    // console.log('savedSearch::', savedSearch)

    getSearchCriteria(savedSearch)

    setSearchFields(searchFields)
    setSearchCriteria(searchCriteria)

    setCriteriaProcessedIns(true)
}

const setSearchFieldValue = (array, key, fieldName, update, value) => {
    const i = array[key].findIndex(x => x.fieldName === fieldName)
    if (i !== -1) {
        array[key][i][update] = value
    }
    return array
}

const setSearchCriteriaValue = (returnVal, key, fieldName) => {
    const i = searchFields[key].findIndex(x => x.fieldName === fieldName)
    if (i !== -1) {
        returnVal[key].push(searchFields[key][i])
    }
    return returnVal
}

export function getOVSearchCriteria(ovSearchCriteria) {
    isLoadSavedSearch = false
    SetupSearchCriteriaAndFields()
    omniViewSearchCriteria = JSON.parse(ovSearchCriteria)
    iterateSearchCriteria()

    // console.log('searchCriteria = ', searchCriteria)
    // console.log('searchFields = ', searchFields)
    return searchCriteria // searchCriteria
}

export function loadOVSearchCriteria(ovSearchCriteria, setSearchFieldsIns, setSearchCriteriaIns, setCriteriaProcessedIns) {
    isLoadSavedSearch = true
    SetupSearchCriteriaAndFields()

    omniViewSearchCriteria = JSON.parse(ovSearchCriteria)
    setSearchCriteria = setSearchCriteriaIns
    // keycloak = keycloakIns
    setSearchFields = setSearchFieldsIns
    setCriteriaProcessed = setCriteriaProcessedIns

    // console.log('omniViewSearchCriteria::', omniViewSearchCriteria.searchCriteria)

    const i = omniViewSearchCriteria.searchCriteria.findIndex(x => x.ParameterName === 'PointOfInterest')

    subjectExists = i !== -1 ? true : false

    if (subjectExists) {
        omniViewSearchCriteria.searchCriteria.forEach(item => {
            if (item.ParameterName === 'PointOfInterest') {
                handleSubjectProperty(item)
            }
        })
    } else {
        iterateSearchCriteria()
    }

}

const SetupSearchCriteriaAndFields = () => {
    const SearchCriteriaClsObj = new SearchCriteriaCls()
    searchCriteria = SearchCriteriaClsObj.GetSearchCriteria()

    const SearchFieldsClsObj = new SearchFieldsCls()
    searchFields = SearchFieldsClsObj.GetSearchFields()
}

const iterateSearchCriteria = () => {
    omniViewSearchCriteria.searchCriteria.forEach(item => {

        if (item.ParameterName !== 'OrderBy' && item.PageName !== 'Property_AccountSearch' && item.ParameterName !== 'PointOfInterest') {
            // debugger
            if (item.ParameterName === 'PropertyType') {
                handlePropertyType(item)
            }

            else if (item.ParameterName === 'TenantInfo') {
                handleTenantInfo(item)
            }

            else if (item.ParameterName === 'NearByLocation') {
                handleNearByLocation(item)
            }

            else if (item.ParameterName === 'marketInfo') {
                handleMarketInfo(item)
            }

            else if (item.ParameterName === 'PropertyAddressArea') {
                handleProspecting(item)
            }

            else if (item.ParameterName === 'MSA') {
                handleMSA(item)
            }

            else {
                handleAllOther(item)
            }
        }
    })

    if (isLoadSavedSearch) {
        setCriteriaProcessed(true)
    }

}

// {
//     'PageName' = "PropertySearchNew"
//     'ParameterCond' = "MSAName__c IN (%27Albany GA MSA%27)"
//     'ParameterName' = "MSA"
//     'ParameterValue' = "Albany GA MSA"
// }

// { MetropolitanStateAreaName: "Albany GA MSA" }

function handleMSA(item) {
    try {
        // searchCriteria.prospecting = []
        let parameterCond = item.ParameterCond.toLowerCase().replace(/[()]/g, "")
        // let geoLocation = {}
        // geoLocation.selectedItem = 'MetropolitanStateAreaName'

        parameterCond = parameterCond.replace(/[%27]/g, "")

        let lstParameterCond = parameterCond.split(' or ')

        lstParameterCond.forEach(paramCond => {
            paramCond = paramCond.toLowerCase().replace('msaname__c in', '')

            searchCriteria.prospecting.push({ MetropolitanStateAreaName: paramCond, selectedItem: 'MetropolitanStateAreaName' })
        })

        if (isLoadSavedSearch) {
            setSearchCriteria({ ...searchCriteria })
        }

    } catch (err) {
        console.log('error in handleMSA : ', err)
    }
}


//  "ParameterCond": "((State__c = %27TX%27 AND City__c like %27%25houston%25%27) OR (State__c = %27PA%27))",
function handleProspecting(item) {
    try {
        searchCriteria.prospecting = []
        let parameterCond = item.ParameterCond.toLowerCase().replace(/[()]/g, "")
        let lstParameterCond = parameterCond.split(' or ')

        lstParameterCond.forEach(paramCond => {
            paramCond = paramCond.replace('like', '=')
            const lstParamVal = paramCond.split(' and ')
            let geoLocation = {}
            let state = ''
            lstParamVal.forEach(paramVal => {

                // console.log('paramVal:::', paramVal)
                const lstFinalParam = paramVal.split(' or ')

                lstFinalParam.forEach(finalParam => {
                    const lstgeoLocation = finalParam.split('=')
                    // console.log('finalParam:::', finalParam)

                    let value = lstgeoLocation[1].replace(/[%25]/g, "").replace(/[%27]/g, "")
                    value = value.trim()

                    if (value.includes('sub_branch__c')) {
                        return
                    }

                    if (lstgeoLocation[0].includes('state__c')) {
                        geoLocation.selectedItem = 'state'
                        geoLocation.state = value.toUpperCase()
                        geoLocation.combinedLocation = `${value.toUpperCase()}, USA`
                        state = value.toUpperCase()
                    }
                    value = value.replace(/\b\w/g, l => l.toUpperCase())
                    if (lstgeoLocation[0].includes('city__c')) {
                        geoLocation.selectedItem = 'city'
                        geoLocation.city = value
                        geoLocation.combinedLocation = `${value}, ${state}`
                    }
                    if (lstgeoLocation[0].includes('property_county__c')) {
                        geoLocation.selectedItem = 'propertyCounty'
                        geoLocation.propertyPropertyCounty = value
                        geoLocation.combinedLocation = `${value}, ${state}`
                    }
                    if (lstgeoLocation[0].includes('zip_code__c')) {
                        geoLocation.selectedItem = 'zipCode'
                        geoLocation.zipCode = value
                        geoLocation.combinedLocation = `${value}, ${state}`
                    }
                })


            })

            if (!isEmpty(geoLocation)) {
                searchCriteria.prospecting.push(geoLocation)
            }
        })

        // console.log('prospecting:::', searchCriteria.prospecting)
        if (isLoadSavedSearch) {
            setSearchCriteria({ ...searchCriteria })
        }

        // setSearchFields({ ...searchFields })

    } catch (err) {
        console.log('error in handleProspecting : ', err)
    }
}

function isEmpty(obj) {
    return Object.keys(obj).length === 0;
}

function handleMarketInfo(item) {
    try {
        // "ParameterValue": "Berkadia Listings | Competitor Listings | Berkadia Brokered"
        let lstParameterValue = item.ParameterValue.split('|')
        let parameterCond = item.ParameterCond
        parameterCond = parameterCond.toLowerCase()

        lstParameterValue.forEach(paramValue => {
            paramValue = paramValue.replace(/ /g, '')
            paramValue = paramValue.toLowerCase().trim()

            const i = searchFields.listingStatusFields.findIndex(x => paramValue.includes(x.fieldName.toLowerCase()))
            if (i !== -1) {
                searchFields.listingStatusFields[i].isChecked = true
                if (!isLoadSavedSearch) {
                    searchCriteria.listingStatusFields.push(searchFields.listingStatusFields[i])
                }
            }
        })

        if (isLoadSavedSearch) {
            setSearchFields({ ...searchFields })
        }


    } catch (err) {
        console.log('error in handleMarketInfo : ', err)
    }
}



function handleAllOther(item) {
    try {
        // let lstParameterValue = item.ParameterValue
        let parameterCond = item.ParameterCond
        let lstparameterCond = parameterCond.split(' ')
        let parameterName = item.ParameterName
        let fieldName, category, val, index = ''
        let isMin, isMax = false

        lstparameterCond.forEach(paramCond => {
            let newparamCond = paramCond.toLowerCase()

            const i = fieldMapping.findIndex(x => x.OVfieldName.toLowerCase() === newparamCond.trim())
            if (i !== -1) {
                category = fieldMapping[i].category
                fieldName = fieldMapping[i].fieldName
            }
            else {
                const j = searchFields[category].findIndex(x => x.fieldName.toLowerCase() === fieldName.toLowerCase())
                if (j !== -1) {
                    index = j

                    if (newparamCond.includes('<')) {
                        isMax = true
                    }
                    else if (newparamCond.includes('>')) {
                        isMin = true
                    }
                    else if (!newparamCond.includes('like') && !paramCond.includes('null') && !newparamCond.includes('!=')) {
                        paramCond = paramCond.replace(/%27/g, '')
                        paramCond = paramCond.replace(/#/g, '')
                        val = paramCond
                    }
                }
            }
        })

        let valueSet = false
        // if (parameterName === '_lender') {
        //     searchFields[category][index].value = val
        //     valueSet = true
        // }

        if (isMax && !valueSet) {
            // if (searchFields[category][index].endValue === '') {
            if ('endValue' in searchFields[category][index]) {
                searchFields[category][index].endValue = val
            } else {
                searchFields[category][index].maxValue = val
            }
            valueSet = true
        }
        if (!valueSet) {
            // if (searchFields[category][index].startValue === '') {
            if ('startValue' in searchFields[category][index]) {
                searchFields[category][index].startValue = val
            }
            else if ('value' in searchFields[category][index]) {
                searchFields[category][index].value = val
            }
            else {
                searchFields[category][index].minValue = val
            }
            valueSet = true
        }

        if (!isLoadSavedSearch) {
            searchCriteria[category].push(searchFields[category][index])
        }

        if (isLoadSavedSearch) {
            setSearchFields({ ...searchFields })
        }

    } catch (err) {
        console.log('error in handleAll : ', err)
    }
}

function handleNearByLocation(item) {
    try {
        let lstParameterCond = item.ParameterCond.split(' OR ')
        // parameterCond = parameterCond.toLowerCase()

        lstParameterCond.forEach(paramCond => {
            const paramVal = paramCond.split('=')
            let val = paramVal[1].replace(/%27/g, '').replace(/%25/g, '')
            val = val.replace('(', '')
            val = val.replace(')', '')
            val = val.trim()

            if (paramVal[0].toLowerCase().includes('state__c')) {
                searchFields.locationFields.push({ 'locationType': 'State', 'locationValue': val, 'isChecked': true })
            }
            if (paramVal[0].toLowerCase().includes('city__c')) {
                searchFields.locationFields.push({ 'locationType': 'City', 'locationValue': val, 'isChecked': true })
            }
            if (paramVal[0].toLowerCase().includes('property_county__c')) {
                searchFields.locationFields.push({ 'locationType': 'County', 'locationValue': val, 'isChecked': true })
            }
            if (paramVal[0].toLowerCase().includes('zip_code__c')) {
                searchFields.locationFields.push({ 'locationType': 'Zip Code', 'locationValue': val, 'isChecked': true })
            }
        })

        if (!isLoadSavedSearch) {
            searchCriteria['locationFields'] = searchFields['locationFields']
        }

        if (isLoadSavedSearch) {
            setSearchFields({ ...searchFields })
        }

    } catch (err) {
        console.log('error in handleNearByLocation : ', err)
    }
}

function handleSubjectProperty(item) {
    try {
        let parameterCond = item.ParameterCond
        parameterCond = parameterCond.replace('DISTANCE', '').replace('PropertyAddress__c', '').replace('GEOLOCATION', '')
        parameterCond = parameterCond.replace('PropertyAddress__c', '').replace('mi', '').replace(' ', '')
        parameterCond = parameterCond.replace(/[()]/g, "")

        let lstParameterCond = parameterCond.split(',')
        let propertyLocation = ''

        lstParameterCond.forEach(paramCond => {
            paramCond = paramCond.trim()
            // paramCond.split('<')[1].trim()
            if (paramCond !== '') {
                if (paramCond.length > 3 && !propertyLocation.includes(',')) {
                    propertyLocation = propertyLocation === '' ? paramCond : `${propertyLocation},${paramCond}`
                } else {
                    searchFields.distanceFields[0].value = paramCond.split('<')[1].trim()
                }
            }
        })

        suggestionCriteria.geoLocation.propertyName = item.ParameterValue
        suggestionCriteria.geoLocation.propertyLocation = propertyLocation
        setSearchFields({ ...searchFields })

        fetchSubjectProperty()

    } catch (err) {
        console.log('error in handleSubjectProperty : ', err)
    }
}

async function fetchSubjectProperty() {
    // const response = await APIInterceptor(propertySearchAPIs.propertySuggestion, suggestionCriteria)
    const response = await fetchPropertySuggestion(suggestionCriteria)

    // console.log('result:::', response)
    if (response && response.status === 200) {
        if (response.data && response.data.data) {

            if (response.data.data[0]) {
                let property = response.data.data[0]
                searchCriteria.subjectProperty = property
                searchCriteria.distanceFields.push(searchFields.distanceFields[0])
                searchCriteria.sort = { "byMiles": { "propertyLocation": property.propertyLocation, "order": "asc" } }
                setSearchCriteria({ ...searchCriteria })
            }
            // this condition will be true when POI is a landmark and is Not a subject property
            // we are sending location of landmark and getting all the result
            else {
                if (suggestionCriteria.geoLocation.propertyLocation) {
                    searchCriteria.subjectProperty = {
                        // distance: searchFields.distanceFields[0].value,
                        propertyLocation: suggestionCriteria.geoLocation.propertyLocation,
                        omniViewPropertyId: '',
                        propertyName: suggestionCriteria.geoLocation.propertyName
                    }
                    searchCriteria.sort = { "byMiles": { "propertyLocation": suggestionCriteria.geoLocation.propertyLocation, "order": "asc" } }
                    setSearchCriteria({ ...searchCriteria })
                }
            }
        }
    }
    iterateSearchCriteria()

}

function handleTenantInfo(item) {
    try {
        // "ParameterValue": "Affordable | Age Restricted | Military"
        let lstParameterValue = item.ParameterValue.split('|')
        let parameterCond = item.ParameterCond
        parameterCond = parameterCond.toLowerCase()

        lstParameterValue.forEach(paramValue => {
            const i = searchFields.tenantInfoFields[0].groupList.findIndex(x => x.val.toLowerCase() === paramValue.trim().toLowerCase())
            if (i !== -1) {
                searchFields.tenantInfoFields[0].groupList[i].selected = true

                // if (!setCriteriaProcessed) {
                //     searchCriteria['tenantInfoFields'][0] = searchFields['tenantInfoFields'][0]
                // }
            }
        })

        if (!parameterCond.includes('true') && !parameterCond.includes('yes')) {
            const i = searchFields.tenantInfoFields[0].groupList.findIndex(x => x.key.toLowerCase() === 'exclude')
            searchFields.tenantInfoFields[0].groupList[i].selected = true
        }

        if (isLoadSavedSearch) {
            setSearchFields({ ...searchFields })
        }

    } catch (err) {
        console.log('error in handleTenantInfo : ', err)
    }
}

function handlePropertyType(item) {
    try {
        // "ParameterValue": "Multifamily : All,Health Care : Assisted Living, Other Health Care"

        let lstParameterValue = item.ParameterValue.split(',')
        lstParameterValue.forEach(paramValue => {
            let lstParamValue = paramValue.split(':')
            if (lstParamValue.length) {
                const type = lstParamValue[0].trim()

                if (lstParamValue.length > 1) {
                    const subtype = lstParamValue[1].trim()
                    if (subtype.toLowerCase() === 'all') {
                        const i = searchFields.propertyTypeFields.findIndex(x => x.propertytype.toLowerCase() === type.toLowerCase() && x.subtype === 'all')
                        if (i !== -1) {
                            searchFields.propertyTypeFields[i].isChecked = true
                            if (!isLoadSavedSearch) {
                                searchCriteria['propertyTypeFields'].push(searchFields.propertyTypeFields[i])
                            }

                        }
                    } else {
                        const i = searchFields.propertyTypeFields.findIndex(x => x.subtype.toLowerCase() === subtype.toLowerCase())
                        if (i !== -1) {
                            searchFields.propertyTypeFields[i].isChecked = true
                            if (!isLoadSavedSearch) {
                                searchCriteria['propertyTypeFields'].push(searchFields.propertyTypeFields[i])
                            }
                        }
                    }
                } else {
                    const i = searchFields.propertyTypeFields.findIndex(x => x.subtype.toLowerCase() === type.toLowerCase())
                    if (i !== -1) {
                        searchFields.propertyTypeFields[i].isChecked = true
                        if (!isLoadSavedSearch) {
                            searchCriteria['propertyTypeFields'].push(searchFields.propertyTypeFields[i])
                        }
                    }
                }
            }
            if (isLoadSavedSearch) {
                setSearchFields({ ...searchFields })
            }

        })
    } catch (err) {
        console.log('error in handlePropertyType : ', err)
    }
}
